import { useMemo } from 'react';
import StyledSelect from './StyledSelect';
import { ODD_CHANGES } from '../../../../constants';
import useLocalization from '../../../../hooks/useLocalization';
import { useUpdateUserData, useUserData } from '../../../../queries';
import { SelectChangeEvent } from '@mui/material';
import { OddsChangesType } from '../../../../@types';
import { useAuth } from '@neotech-solutions-org/neofusion-fe-shared';

const SelectOddsChanges = () => {
  const { isAuthenticated } = useAuth();
  const { getLocalizedConfig } = useLocalization();
  const { data: userSettings } = useUserData();
  const localizedOddsChanges = useMemo(() => getLocalizedConfig(ODD_CHANGES), [getLocalizedConfig]);
  const { mutate: updateUserSettings } = useUpdateUserData();

  if (!isAuthenticated) return null;

  const handleChangeOddsChanges = (event: SelectChangeEvent) => {
    const selectedOddsChanges = event.target.value as OddsChangesType;
    updateUserSettings({
      sportsbookConfig: {
        ...(userSettings?.sportsbookConfig || {}),
        oddsChanges: selectedOddsChanges,
      },
    });
  };

  return (
    <StyledSelect
      value={userSettings?.sportsbookConfig?.oddsChanges || ''}
      itemsList={localizedOddsChanges}
      handleChange={handleChangeOddsChanges}
    />
  );
};

export default SelectOddsChanges;
